import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Account Swift Input
 * @component
 * @alias AccountSwiftInput
 * @property {string} initialValue - init value for Form Item
 * @property {bool} readOnly - sets Form Item read-only
 * @property {bool} required - sets Form Item required - default false
 * @returns
 */
const AccountSwiftInput = ({ initialValue, readOnly, required = false }) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      label={t("finance.accounts.accountSwift")}
      name={"account_swift"}
      initialValue={initialValue}
      hasFeedback
      rules={[
        {
          required: required,
          min: 8,
          max: 11,
          message: t("finance.accounts.validation.accountSwift"),
        },
      ]}
    >
      <Input maxLength={11} readOnly={readOnly} bordered={!readOnly}></Input>
    </Form.Item>
  );
};

export default AccountSwiftInput;
